import * as types from 'store/modules/hres31x/mutation-types'
import hres31x from 'api/hres31x'
import hres31xLabels from 'assets/labels/hres31x'
import { hres31xColumns } from 'assets/columns/hres31x'
import configLabel from 'src/../config/label'
import swal from 'sweetalert'

export default {
  state: {
    labels: hres31xLabels,
    columns: hres31xColumns(),
    detail: {
      index: {},
      topic: {},
      tab1: {},
      tab2: {},
      tab3: {},
      tab4: {
        tableIncome: {},
        detail: {}
        // tableSummary: {}
      },
      tab5: {
        detail: {},
        tableTaxExemption: {},
        tableTaxDeduction: {},
        tableOtherDeduction: {}
      },
      tab6: {
        tableEducation: {}
      },
      tab7: {
        tableExpWork: {}
      },
      tab8: {},
      tab9: {},
      tab10: {
        tableChildData: {}
      },
      tab11: {
        tableGuarantor: {}
      },
      tab12: {
        tableAssetData: {}
      },
      tab13: {
        tableTalentType: {},
        tableTalentData: {}
      },
      tab14: {
        tableTrainingData: {}
      },
      tab15: {
        tableHonorsData: {}
      },
      tab16: {
        tableChangeName: {}
      },
      tab17: {
        tableDocument: {}
      },
      tab18: {
        tablePersonRef: {}
      },
      tab19: {
        tableEtcData: {}
      }
    },
    detailTab13Popup: {
      total: 0,
      rows: []
    }
  },
  getters: {
    [types.GET_HRES31X_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES31X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES31X_DETAIL_INDEX] (state) {
      return state.detail.index
    },
    [types.GET_HRES31X_DETAIL_TOPIC] (state) {
      return state.detail.topic
    },
    [types.GET_HRES31X_DETAIL_TAB1] (state) {
      return state.detail.tab1
    },
    [types.GET_HRES31X_DETAIL_TAB2] (state) {
      return state.detail.tab2
    },
    [types.GET_HRES31X_DETAIL_TAB3] (state) {
      return state.detail.tab3
    },
    [types.GET_HRES31X_DETAIL_TAB4] (state) {
      return state.detail.tab4
    },
    [types.GET_HRES31X_DETAIL_TAB5] (state) {
      return state.detail.tab5
    },
    [types.GET_HRES31X_DETAIL_TAB6] (state) {
      return state.detail.tab6
    },
    [types.GET_HRES31X_DETAIL_TAB7] (state) {
      return state.detail.tab7
    },
    [types.GET_HRES31X_DETAIL_TAB8] (state) {
      return state.detail.tab8
    },
    [types.GET_HRES31X_DETAIL_TAB9] (state) {
      return state.detail.tab9
    },
    [types.GET_HRES31X_DETAIL_TAB10] (state) {
      return state.detail.tab10
    },
    [types.GET_HRES31X_DETAIL_TAB11] (state) {
      return state.detail.tab11
    },
    [types.GET_HRES31X_DETAIL_TAB12] (state) {
      return state.detail.tab12
    },
    [types.GET_HRES31X_DETAIL_TAB13] (state) {
      return state.detail.tab13
    },
    [types.GET_HRES31X_DETAIL_TAB14] (state) {
      return state.detail.tab14
    },
    [types.GET_HRES31X_DETAIL_TAB15] (state) {
      return state.detail.tab15
    },
    [types.GET_HRES31X_DETAIL_TAB16] (state) {
      return state.detail.tab16
    },
    [types.GET_HRES31X_DETAIL_TAB17] (state) {
      return state.detail.tab17
    },
    [types.GET_HRES31X_DETAIL_TAB18] (state) {
      return state.detail.tab18
    },
    [types.GET_HRES31X_DETAIL_TAB19] (state) {
      return state.detail.tab19
    },
    [types.GET_HRES31X_DETAIL_TAB13_POPUP] (state) {
      return state.detailTab13Popup
    }
  },
  mutations: {
    [types.SET_HRES31X_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].detailTab13Popup = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab13Popup, labels[keyLang])
      }
    },
    [types.SET_HRES31X_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES31X_DETAIL_INDEX] (state, data) {
      state.detail.index = data
    },
    [types.SET_HRES31X_DETAIL_TOPIC] (state, data) {
      state.detail.topic = data
    },
    [types.SET_HRES31X_DETAIL_TAB1] (state, data) {
      state.detail.tab1 = data
    },
    [types.SET_HRES31X_DETAIL_TAB2] (state, data) {
      state.detail.tab2 = data
    },
    [types.SET_HRES31X_DETAIL_TAB3] (state, data) {
      state.detail.tab3 = data
    },
    [types.SET_HRES31X_DETAIL_TAB4] (state, data) {
      state.detail.tab4 = data
    },
    [types.SET_HRES31X_DETAIL_TAB5] (state, data) {
      state.detail.tab5 = data
    },
    [types.SET_HRES31X_DETAIL_TAB6] (state, data) {
      state.detail.tab6 = data
    },
    [types.SET_HRES31X_DETAIL_TAB7] (state, data) {
      state.detail.tab7 = data
    },
    [types.SET_HRES31X_DETAIL_TAB8] (state, data) {
      state.detail.tab8 = data
    },
    [types.SET_HRES31X_DETAIL_TAB9] (state, data) {
      state.detail.tab9 = data
    },
    [types.SET_HRES31X_DETAIL_TAB10] (state, data) {
      state.detail.tab10 = data
    },
    [types.SET_HRES31X_DETAIL_TAB11] (state, data) {
      state.detail.tab11 = data
    },
    [types.SET_HRES31X_DETAIL_TAB12] (state, data) {
      state.detail.tab12 = data
    },
    [types.SET_HRES31X_DETAIL_TAB13] (state, data) {
      state.detail.tab13 = data
    },
    [types.SET_HRES31X_DETAIL_TAB14] (state, data) {
      state.detail.tab14 = data
    },
    [types.SET_HRES31X_DETAIL_TAB15] (state, data) {
      state.detail.tab15 = data
    },
    [types.SET_HRES31X_DETAIL_TAB16] (state, data) {
      state.detail.tab16 = data
    },
    [types.SET_HRES31X_DETAIL_TAB17] (state, data) {
      state.detail.tab17 = data
    },
    [types.SET_HRES31X_DETAIL_TAB18] (state, data) {
      state.detail.tab18 = data
    },
    [types.SET_HRES31X_DETAIL_TAB19] (state, data) {
      state.detail.tab19 = data
    },
    [types.SET_HRES31X_DETAIL_TAB13_POPUP] (state, data) {
      state.detailTab13Popup = data
    }
  },
  actions: {
    [types.RECEIVED_HRES31X_COLUMNS_LABELS] ({ commit }) {
      hres31x.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES31X_COLUMNS, data.labels)
          commit(types.SET_HRES31X_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES31X_DETAIL_INDEX] ({ commit }) {
      hres31x.getDetailIndex()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES31X_DETAIL_INDEX, data.index)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES31X_DETAIL_TOPIC] ({ commit }) {
      hres31x.getDetailTopic()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES31X_DETAIL_TOPIC, data.topic)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES31X_DETAIL_TAB1] ({ commit }) {
      hres31x.getDetailTab1()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES31X_DETAIL_TAB1, data.tab1)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES31X_DETAIL_TAB2_19] ({ commit }) {
      hres31x.getDetailTab2_19()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES31X_DETAIL_TAB2, data.tab2)
          commit(types.SET_HRES31X_DETAIL_TAB3, data.tab3)
          commit(types.SET_HRES31X_DETAIL_TAB4, data.tab4)
          commit(types.SET_HRES31X_DETAIL_TAB5, data.tab5)
          commit(types.SET_HRES31X_DETAIL_TAB6, data.tab6)
          commit(types.SET_HRES31X_DETAIL_TAB7, data.tab7)
          commit(types.SET_HRES31X_DETAIL_TAB8, data.tab8)
          commit(types.SET_HRES31X_DETAIL_TAB9, data.tab9)
          commit(types.SET_HRES31X_DETAIL_TAB10, data.tab10)
          commit(types.SET_HRES31X_DETAIL_TAB11, data.tab11)
          commit(types.SET_HRES31X_DETAIL_TAB12, data.tab12)
          commit(types.SET_HRES31X_DETAIL_TAB13, data.tab13)
          commit(types.SET_HRES31X_DETAIL_TAB14, data.tab14)
          commit(types.SET_HRES31X_DETAIL_TAB15, data.tab15)
          commit(types.SET_HRES31X_DETAIL_TAB16, data.tab16)
          commit(types.SET_HRES31X_DETAIL_TAB17, data.tab17)
          commit(types.SET_HRES31X_DETAIL_TAB18, data.tab18)
          commit(types.SET_HRES31X_DETAIL_TAB19, data.tab19)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES31X_DETAIL_TAB13_POPUP] ({ commit }, popupParams) {
      hres31x.getDetailTab13Popup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES31X_DETAIL_TAB13_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres31x/index.js